import Keycloak from 'keycloak-js';
import type { KeycloakInitOptions } from 'keycloak-js';

/**
 * Single Keycloak instance for the SPA.
 *
 * IMPORTANT: permissions ALWAYS come from JWT claims here — never from localStorage,
 * never from Zustand state, never from URL params (spec S02 §2.6).
 */
export const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
});

// Keycloak's `init()` may only be called once per instance, but React 18
// StrictMode mounts effects twice in dev. Memoise the promise so every
// caller awaits the same initialisation.
let initPromise: Promise<boolean> | null = null;

export function initKeycloak(options: KeycloakInitOptions): Promise<boolean> {
  if (initPromise === null) {
    initPromise = keycloak.init(options);
  }
  return initPromise;
}
